import { render, staticRenderFns } from "./SelectChannel.vue?vue&type=template&id=0a79ae96"
import script from "./SelectChannel.vue?vue&type=script&lang=ts"
export * from "./SelectChannel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports